/**
 * @module store/mutation-types
 *
 * @version 1.0.0
 * @copyright Kosmos 2018
 */

/**
 * Функция хелпер, которая позволяет генерировать названия мутаций для асинхронных экшинов
 *
 * @param {string} type - Строка, на основании которой будут сгенерированны названия мутаций
 */
const createAsyncMutation = type => ({
  SUCCESS: `${type}_SUCCESS`,
  FAILURE: `${type}_FAILURE`,
  PENDING: `${type}_PENDING`,
  // loadingKey: `${type}_PENDING`,
  // stateKey: `${type}_DATA`,
});


// User
export const SET_USER = 'SET_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const UPDATE_IMAGE = 'UPDATE_IMAGE';

// Points
export const SET_POINTS = 'SET_POINTS';
export const GET_POINTS_ASYNC = createAsyncMutation('GET_POINTS');

// Promos
export const SET_PROMOS = 'SET_PROMOS';
export const GET_PROMOS_ASYNC = createAsyncMutation('GET_PROMOS');

// Settings
export const SET_SETTINGS = 'SET_SETTINGS';

// Stats
export const GET_STATS_ASYNC = createAsyncMutation('GET_STATS');

// E-Mails
export const GET_EMAILS_ASYNC = createAsyncMutation('GET_EMAILS');

// Users
export const GET_USERS_ASYNC = createAsyncMutation('GET_USERS');

// Foundations
export const GET_FOUNDATIONS_ASYNC = createAsyncMutation('GET_FOUNDATIONS');

// Marathons
export const GET_MARATHONS_ASYNC = createAsyncMutation('GET_MARATHONS');

// Promocodes
export const GET_PROMOCODES_ASYNC = createAsyncMutation('GET_PROMOCODES');

// Starts organizers
export const GET_STARTS_ORGANIZERS_ASYNC = createAsyncMutation('GET_STARTS_ORGANIZERS');

// System start organizer
export const GET_SYSTEM_START_ORGANIZER_ASYNC = createAsyncMutation('GET_SYSTEM_START_ORGANIZER');

// Challenges
export const GET_CHALLENGES_ASYNC = createAsyncMutation('GET_CHALLENGES');

// E-Mails
export const GET_TAX_KINDCHALLENGE_ASYNC = createAsyncMutation('GET_TAX_KINDCHALLENGE');

// Slides
export const GET_SLIDES_ASYNC = createAsyncMutation('GET_SLIDES');
